export const table = {
	name: 'table',
	title: 'View as table',
	content:
		'<rect x="0.75" y="0.753" width="22.5" height="4.5" rx="1.5" ry="1.5" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></rect><rect x="0.75" y="9.753" width="22.5" height="4.5" rx="1.5" ry="1.5" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></rect><rect x="0.75" y="18.753" width="22.5" height="4.5" rx="1.5" ry="1.5" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></rect>',
};
